<div class="cookie-banner" *ngIf="!isGdpr">
    <div>
        <p>
            This website uses cookies necessary to make our site work. We also use cookies to
            improve your experience and for analytics. Do you accept the use of these non-essential
            cookies?
            <a [href]="privacyPoliciesUrl" target="_blank" rel="noopener">Privacy Policy</a>
        </p>
    </div>
    <div>
        <button mat-flat-button primaryButton (click)="accept()">Accept</button>
        <button mat-button color="primary" (click)="reject()">Reject</button>
    </div>
</div>
